import script from "./completeModel.vue?vue&type=script&setup=true&lang=js"
export * from "./completeModel.vue?vue&type=script&setup=true&lang=js"

import "./completeModel.vue?vue&type=style&index=0&id=71ef3aec&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ef3aec"]])

export default __exports__